import React from 'react';
import { NavLink } from 'react-router-dom';
import './CSS/policy.css';

const SiteMap = () => {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>Site Map – Sri Sairam Advertising</h1>
                
                <p>
                    Navigate through our website easily using the site map below. Find all our services, about us, and policy information in one place.
                </p>

                <hr />

                <section>
                    <h2>Main Pages</h2>
                    <ul>
                        <li><NavLink to="/">Home</NavLink></li>
                        <li><NavLink to="/about">About Us</NavLink></li>
                        <li><NavLink to="/blog">Blog</NavLink></li>
                        <li><NavLink to="/contact">Contact Us</NavLink></li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>Our Services</h2>
                    <ul>
                        <li><NavLink to="/service/newspaper">Newspaper Advertising</NavLink></li>
                        <li><NavLink to="/service/digital">Digital Advertising</NavLink></li>
                        <li><NavLink to="/service/webDesign">Web Designing</NavLink></li>
                        <li><NavLink to="/service/graphic">Graphic Designing</NavLink></li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>Policies & Legal</h2>
                    <ul>
                        <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                        <li><NavLink to="/refund-policy">Refund & Cancellation Policy</NavLink></li>
                        <li><NavLink to="/terms-conditions">Terms & Conditions</NavLink></li>
                        <li><NavLink to="/disclaimer">Disclaimer</NavLink></li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>Admin & Staff</h2>
                    <ul>
                        <li><NavLink to="/admin">Admin Login</NavLink></li>
                        <li><NavLink to="/staff">Staff Portal</NavLink></li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>Contact Us</h2>
                    <div className="contact-info">
                        <p><strong>Sri Sairam Advertising</strong></p>
                        <p>No.2, Svs Nagar 1st Main Road, Valasaravakkam, Chennai-87</p>
                        <p>📞 +91 95000 37429 / 95000 57429</p>
                        <p>✉️ sai29ads@gmail.com / info@srisairamadvertising.com</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SiteMap;
